import { render, staticRenderFns } from "./menu-item.vue?vue&type=template&id=398dbe1e"
import script from "./menu-item.vue?vue&type=script&lang=js"
export * from "./menu-item.vue?vue&type=script&lang=js"
import style0 from "./menu-item.vue?vue&type=style&index=0&id=398dbe1e&prod&lang=stylus"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports